import SongForm from "../../components/SongForm/SongForm";

const SongFormPage = () => {
  return <SongForm />;
};

export default SongFormPage;
